import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { DataService_SchoolIncidentSetup } from "../shared/data.service";
import { SchoolIncidentUpdateRequest } from "../shared/SchoolIncidentUpdateRequest";
import * as moment from "moment";

@Component({
	selector: "app-edit-school-incident",
	templateUrl: "./edit-school-incident.component.html",
	styleUrls: ["./edit-school-incident.component.css"],
})
export class EditSchoolIncidentComponent implements OnInit {
	constructor(
		private dialogConfig: DynamicDialogConfig,
		private ref: DynamicDialogRef,
		private confirmationService: ConfirmationService,
		private SchoolIncidentSetupService: DataService_SchoolIncidentSetup
	) {}

	ngOnInit(): void {
		this.SchoolID = this.dialogConfig.data.SchoolID;
		this.SelectedIncident = this.dialogConfig.data.SelectedIncident;

		this.Comments = this.SelectedIncident.Comment;

		var fDate = this.SelectedIncident.IncidentDT;
		this.IncidentDate = new Date(fDate);
		this.IncidentTime = new Date(fDate);

		this.LoadIncidentTypes();
	}

	//////////////////////////////////////
	// Data
	//////////////////////////////////////

	//Data from Parent
	SchoolID: any;
	SelectedIncident: any;

	//Form
	SchoolIncidentTypeID: any;
	lstSchoolIncidentType: any = [];
	IncidentDate: Date = new Date();
	IncidentTime: Date = new Date();
	Comments: string = "";

	errorMessage: any = "";

	//////////////////////////////////////

	//////////////////////////////////////
	// Load Data
	//////////////////////////////////////
	LoadIncidentTypes() {
		var result = this.SchoolIncidentSetupService.SchoolIncidentTypeSelectList(this.SchoolID);
		result.subscribe(
			(response) => {
				this.lstSchoolIncidentType = response;

				this.SchoolIncidentTypeID = this.lstSchoolIncidentType[0].SchoolIncidentTypeID;

				this.SchoolIncidentTypeID = this.SelectedIncident.SchoolIncidentTypeID;
			},
			(error) => {}
		);
	}

	//////////////////////////////////////

	//////////////////////////////////////
	// Buttons
	//////////////////////////////////////
	onEdit() {
		this.errorMessage = "";

		//Error handling
		var fDate = moment(this.IncidentDate).format("MM/DD/YYYY") + " " + moment(this.IncidentTime).format("HH:mm:ss");
		if (fDate == "" || fDate == undefined || String(fDate).toLowerCase().indexOf("invalid") != -1) {
			this.errorMessage = "Invalid Date or Time";
			return;
		}

		if (String(this.Comments).length > 512) {
			this.errorMessage = "Comments cannot be longer than 512 characters";
			return;
		}

		let parms: SchoolIncidentUpdateRequest = {
			SchoolIncidentID: this.SelectedIncident.SchoolIncidentID,
			SchoolIncidentTypeID: this.SchoolIncidentTypeID,
			IncidentDT: fDate,
			Comment: this.Comments,
		};

		//Call SP
		var result = this.SchoolIncidentSetupService.SchoolIncidentUpdate(parms);
		result.subscribe(
			(response) => {
				if (response) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "edit",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "School Incident was updated successfully",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.ref.close(1);
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "edit",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not update the School Incident",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {}
		);
	}

	onClose() {
		this.ref.close(0);
	}
	//////////////////////////////////////
}
